import { render } from "./ModalErrorMsg.vue?vue&type=template&id=ffc0fc00&scoped=true"
import script from "./ModalErrorMsg.vue?vue&type=script&lang=js"
export * from "./ModalErrorMsg.vue?vue&type=script&lang=js"

import "./ModalErrorMsg.vue?vue&type=style&index=0&id=ffc0fc00&scoped=true&lang=scss"

import exportComponent from "/home/ben/code/nft_ticket/nft_ticket_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffc0fc00"]])

export default __exports__